import { Controller } from "@hotwired/stimulus"
import { applyTheme } from "../utils/theme_transition"

// Préférence « auto » : même logique que os_theme_controller (body), pour les visites Turbo
// où le formulaire sidebar est présent.
// Connects to data-controller="user-settings-form"
export default class extends Controller {
  connect() {
    this.syncFromOs()
    document.addEventListener("turbo:load", this.syncFromOs)
    document.addEventListener("turbo-frame:load", this.syncFromOs)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.syncFromOs)
    document.removeEventListener("turbo-frame:load", this.syncFromOs)
  }

  syncFromOs = () => {
    if (document.body?.dataset.themePreference !== "auto") return

    applyTheme("auto")

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    if (!token) return

    const resolved = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
    fetch("/set_theme", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ theme: resolved })
    }).catch(() => {})
  }
}
